export function salariesReducer(state = "",{
    type,
    payload
}){
    
    switch(type){
        case "NEW_SALARY":            
        case "UPDATE_SALARY":
        case "UPDATE_FETCH_SALARY":            
            let list = Object.assign({}, state);
            // delete list[payload.salary_id]
            list[payload.salary_id] = payload
            
            return list
        case "GET_SALARIES":
            return payload
        case "DELETE_SALARY":            
            let list2 = Object.assign({}, state);

            delete list2[payload]
            
            return list2
            
        default:
            return state;
    }
    
}